import React, { Component } from "react";
import { FirebaseContext } from "../../FirebaseInit";
import { Redirect } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  LinearProgress,
  CssBaseline,
} from "@material-ui/core";
import {
  createMuiTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@material-ui/core/styles";
import Nav from "../Nav/Nav";
import ChatList from "../ChatList/ChatList";
import Chat from "../Chat/Chat";
import DialogHost from "../DialogHost/DialogHost";
import AlertHost from "../AlertHost/AlertHost";
import { lightBlue, pink } from "@material-ui/core/colors";

const validateTheme = (userTheme) => {
  const { primaryColor, secondaryColor, theme } = userTheme;
  const regex = /^#[0-9A-F]{6}$/i;
  const validThemes = ["dark", "light"];
  return (
    primaryColor.match(regex) &&
    secondaryColor.match(regex) &&
    validThemes.includes(theme)
  );
};

const defaultTheme = {
  primaryColor: lightBlue[700],
  secondaryColor: pink[700],
  theme: "dark",
};
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      userDeleted: false,
      loading: true,
      chatMobVisible: true,
      dialogOpen: false,
      dialogName: "",
      dialogTitle: "",
      dialogInfo: null,
      chat: null,
      chaType: "",
      chatDeleted: false,
      alertOpen: false,
      alertType: "success",
      alertMessage: "",
      appearance: defaultTheme,
    };

    this.toggleChatList = this.toggleChatList.bind(this);
    this.toggleDialog = this.toggleDialog.bind(this);
    this.userDeleted = this.userDeleted.bind(this);
    this.selectChat = this.selectChat.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.chatDeleted = this.chatDeleted.bind(this);
  }

  toggleChatList() {
    this.setState({ chatMobVisible: !this.state.chatMobVisible });
  }

  chatDeleted() {
    this.setState({ chat: null, chaType: "", chatDeleted: true });
  }

  toggleDialog(name, title, info) {
    if (name === "close") {
      this.setState({
        dialogOpen: !this.state.dialogOpen,
      });
      return;
    }
    this.setState({
      dialogOpen: !this.state.dialogOpen,
      dialogName: name,
      dialogTitle: title,
      dialogInfo: info,
    });
  }

  userDeleted() {
    this.setState({ userDeleted: true });
  }

  selectChat(chat, type) {
    this.setState({
      chat: chat,
      chaType: type,
      chatMobVisible: false,
      chatDeleted: false,
    });
  }

  toggleAlert(message, type) {
    if (!message && !type) {
      this.setState({ alertOpen: false });
      return;
    }
    this.setState({ alertMessage: message, alertType: type, alertOpen: true });
  }

  componentDidMount() {
    const firebase = this.context;
    this.userListener = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        let userStatusRef = firebase.db().ref("/status/" + user.uid);
        let isOffline = {
          state: "offline",
          last_changed: firebase.db.ServerValue.TIMESTAMP,
        };

        let isOnline = {
          state: "online",
          last_changed: firebase.db.ServerValue.TIMESTAMP,
        };
        this.statusRef = firebase.db().ref(".info/connected");
        this.dbListener = this.statusRef.on("value", (snap) => {
          if (snap.val() === false) {
            return;
          }

          userStatusRef
            .onDisconnect()
            .set(isOffline)
            .then(() => {
              userStatusRef.set(isOnline);
            });
        });

        this.userThemeListener = firebase
          .fs()
          .collection("users")
          .doc(user.uid)
          .collection("private")
          .doc("theme")
          .onSnapshot((doc) => {
            if (doc.exists) {
              const appearance = {
                primaryColor: doc.data().primaryColor,
                secondaryColor: doc.data().secondaryColor,
                theme: doc.data().theme,
              };

              this.setState({
                appearance: validateTheme(appearance)
                  ? appearance
                  : defaultTheme,
                user,
                loading: false,
              });
            } else {
              this.setState({ user, loading: false });
            }
          });
      } else this.setState({ user: null, loading: false });
    });
  }

  componentWillUnmount() {
    this.userListener && this.userListener();
    this.userThemeListener && this.userThemeListener();
    this.statusRef && this.statusRef.off("value", this.dbListener);
  }

  render() {
    const {
      user,
      loading,
      chatMobVisible,
      dialogOpen,
      dialogTitle,
      dialogName,
      dialogInfo,
      userDeleted,
      chat,
      chaType,
      alertOpen,
      alertType,
      alertMessage,
      appearance,
      chatDeleted,
    } = this.state;
    if (loading) return <LinearProgress />;
    else {
      if (user) {
        const userTheme = responsiveFontSizes(
          createMuiTheme({
            palette: {
              primary: {
                main: appearance.primaryColor,
                contrastText: "#ffffff",
              },
              secondary: {
                main: appearance.secondaryColor,
                contrastText: "#ffffff",
              },

              type: appearance.theme,
            },
          })
        );
        return (
          <ThemeProvider theme={userTheme}>
            <CssBaseline />
            <Box height="100vh">
              <Nav
                user={user}
                toggleDialog={this.toggleDialog}
                toggleChatList={this.toggleChatList}
              />
              <ChatList
                user={user}
                chatMobVisible={chatMobVisible}
                toggleChatList={this.toggleChatList}
                selectChat={this.selectChat}
                toggleAlert={this.toggleAlert}
                chatDeleted={chatDeleted}
              />

              <Chat
                toggleDialog={this.toggleDialog}
                toggleAlert={this.toggleAlert}
                user={user}
                chaType={chaType}
                chat={chat}
                chatDeleted={chatDeleted}
              />

              <DialogHost
                userDeleted={this.userDeleted}
                user={user}
                group={chaType === "group" ? chat : null}
                chat={chaType === "private" ? chat : null}
                toggleDialog={this.toggleDialog}
                dialogOpen={dialogOpen}
                toggleAlert={this.toggleAlert}
                dialogTitle={dialogTitle}
                dialogName={dialogName}
                dialogInfo={dialogInfo}
                appearance={appearance}
                chatDeleted={this.chatDeleted}
              />

              <AlertHost
                open={alertOpen}
                type={alertType}
                message={alertMessage}
                toggleAlert={this.toggleAlert}
              />
            </Box>
          </ThemeProvider>
        );
      } else
        return userDeleted ? (
          <Box
            height="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <Typography paragraph align="center" variant="h3">
              Account deleted successfully
            </Typography>
            <Button
              color="primary"
              variant="outlined"
              size="large"
              onClick={() => this.props.history.push("/")}
            >
              Take me home
            </Button>
          </Box>
        ) : (
          <Redirect to="/welcome" />
        );
    }
  }
}
Dashboard.contextType = FirebaseContext;
export default Dashboard;
